export default "__VITE_ASSET__D4USPmLU__"